// fallow-ignore-file unused-file -- Loaded from layout/theme.liquid through Shopify's asset_url filter.
(function () {
  'use strict';

  if (window.tileAddToCartInitialized) return;
  window.tileAddToCartInitialized = true;

  document.addEventListener('click', function (event) {
    const collectionCard = event.target.closest('.block-collection');
    if (!collectionCard) return;

    const collectionLink = collectionCard.querySelector('.stretched-link');
    if (collectionLink && collectionLink.href) window.location.href = collectionLink.href;
  });

  document.addEventListener('click', function (event) {

    const card = event.target.closest('.block-product');
    if (!card) return;

    if (event.target.closest('.js-block-add-to-cart') || event.target.closest('.js-product-wishlist-add') || event.target.closest('.js-product-wishlist-remove')) return;

    const link = card.querySelector('.stretched-link');
    if (link && link.href) window.location.href = link.href;
  });

  document.addEventListener('click', function (event) {
    const button = event.target.closest('.js-block-add-to-cart');
    if (!button || button.disabled) return;

    event.preventDefault();
    event.stopPropagation();

    const variantId = button.dataset.variantId;
    const canonicalCard = button.closest('[data-card-variant-id]');
    const searchCard = button.closest('[data-search-attribution]');
    // Capture the verified search identity before the asynchronous mutation.
    const captured = searchCard && canonicalCard?.dataset.cardVariantId === variantId && searchCard.dataset.searchId === variantId
      ? window.florafySearchAttribution?.capture(searchCard) : null;
    const searchAdd = captured ? { ...captured, eventId: crypto.randomUUID().replace(/-/g, '') } : null;
    let mutationSucceeded = false;
    button.classList.add('is-loading');
    button.disabled = true;

    const icon = button.querySelector('.btn-icon__icon i');
    const originalIconClass = icon ? icon.className : '';
    if (icon) icon.className = 'fa-solid fa-spinner';

    const pathParts = window.location.pathname.split('/').filter(Boolean);
    const minicartUrl = pathParts.length > 0 ? `/${pathParts[0]}/?section_id=base-minicart` : '/?section_id=base-minicart';

    const properties = window.deliveryMatchPropertiesFromElement
      ? window.deliveryMatchPropertiesFromElement(button)
      : {};
    const item = { id: parseInt(variantId, 10), quantity: 1 };
    if (Object.keys(properties).length) item.properties = properties;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [item] }),
    })
      .then(async (response) => {
        if (!response.ok) throw new Error('Add to cart failed');
        mutationSucceeded = true;
        // Successful mutation stays successful if parsing or the later drawer
        // refresh fails. Statistics never retry the Shopify mutation.
        if (searchAdd) {
          try {
            const added = await response.json();
            const confirmed = Array.isArray(added.items) && added.items.some((line) => String(line.variant_id || line.id) === variantId && Number.isInteger(line.quantity) && line.quantity > 0);
            if (confirmed) document.dispatchEvent(new CustomEvent('product-card:added', { detail: searchAdd }));
          } catch { /* No confirmed line means no cart attribution. */ }
        }

        button.classList.remove('is-loading');
        button.classList.add('is-success');
        if (icon) icon.className = 'fa-solid fa-check';
        if (window.setMinicartLoading) window.setMinicartLoading(true);

        return Promise.all([fetch('/cart.js').then((response) => response.json()), fetch(minicartUrl).then((response) => response.text())]);
      })
      .then(([cart, minicartHtml]) => {
        document.querySelectorAll('.js-cart-count').forEach((element) => {
          element.textContent = cart.item_count;
          element.classList.remove('cart-bounce');
          void element.offsetWidth;
          element.classList.add('cart-bounce');
        });

        const cartIcon = document.querySelector('.js-cart-count');
        if (cartIcon) cartIcon.classList.add('header-main__cart--hasitems');

        requestAnimationFrame(() => {
          try {
            const temporaryContainer = document.createElement('div');
            temporaryContainer.innerHTML = minicartHtml;
            const newContent = temporaryContainer.querySelector('.drawer-cart');
            const minicart = document.querySelector('.drawer-cart');
            if (minicart && newContent) minicart.innerHTML = newContent.innerHTML;
            if (minicart) minicart.classList.add('is-open');
          } finally {
            if (window.setMinicartLoading) window.setMinicartLoading(false);
          }
        });

        setTimeout(() => {
          button.classList.remove('is-success');
          button.disabled = false;
          if (icon) icon.className = originalIconClass;
        }, 2000);
      })
      .catch((error) => {
        if (window.setMinicartLoading) window.setMinicartLoading(false);
        console.error(mutationSucceeded ? 'Cart refresh error:' : 'Add to cart error:', error);
        button.classList.remove('is-loading');
        button.disabled = false;
        if (icon) icon.className = originalIconClass;
      });
  });

  function showWishlistToast(message) {
    const existingToast = document.querySelector('.wishlist-toast');
    if (existingToast) existingToast.remove();

    const toast = document.createElement('div');
    toast.className = 'wishlist-toast';
    toast.innerHTML = `
      <i class="fa-sharp fa-solid fa-heart wishlist-toast__icon"></i>
      <span class="wishlist-toast__message">${message}</span>
    `;
    document.body.appendChild(toast);

    setTimeout(() => toast.classList.add('show'), 10);
    setTimeout(() => {
      toast.classList.remove('show');
      setTimeout(() => toast.remove(), 300);
    }, 3000);
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest('.js-product-wishlist-add');
    if (!button) return;
    event.preventDefault();
    const productId = button.getAttribute('data-id');
    const userWishlist = JSON.parse(localStorage.getItem('userWishlist')) || [];
    if (!userWishlist.includes(productId)) {
      userWishlist.push(productId);
      showWishlistToast(window.translations?.wishlist?.added || 'Added to wishlist');
    }
    localStorage.setItem('userWishlist', JSON.stringify(userWishlist));
    window.dispatchEvent(new Event('wishlist:changed'));
    button.classList.add('added-to-wishlist');
  });
})();
